import * as Api from '@ViewModels';
import moment from 'moment';
import type {
	CloseMonthRow,
	DealSizeBucketRow,
	DealSizeByStageRow,
	OwnerOrCompanyRow,
	TagAggregateRow,
} from './opportunityReportingChartTypes';

export function mapApiRowsToDealSizeByStage(rows: Api.IOpportunityReportingChartRow[]): DealSizeByStageRow[] {
	return rows.map(r => ({
		stageName: r.label,
		dealSize: r.value,
		count: r.count,
	}));
}

export function mapApiRowsToCloseMonth(rows: Api.IOpportunityReportingChartRow[]): CloseMonthRow[] {
	return rows
		.map(r => {
			const parsed = moment(r.label);
			const monthKey = parsed.isValid() ? parsed.format('YYYY-MM') : r.label;
			return {
				monthKey,
				label: parsed.isValid() ? parsed.format('MMM YYYY') : r.label,
				count: r.count,
				dealSize: r.value,
			};
		})
		.sort((a, b) => a.monthKey.localeCompare(b.monthKey));
}

export function mapApiRowsToTag(rows: Api.IOpportunityReportingChartRow[]): TagAggregateRow[] {
	return rows.map(r => ({
		tag: r.label,
		count: r.count,
		dealSize: r.value,
	}));
}

export function mapApiRowsToDealSizeBuckets(rows: Api.IOpportunityReportingChartRow[]): DealSizeBucketRow[] {
	return rows.map(r => ({
		range: r.label,
		count: r.count,
		dealSize: r.value,
	}));
}

export function mapApiRowsToOwnerOrCompany(rows: Api.IOpportunityReportingChartRow[]): OwnerOrCompanyRow[] {
	return rows.map(r => ({
		label: r.label,
		count: r.count,
		dealSize: r.value,
	}));
}
